import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Plus, Edit2, Trash2, MessageSquare } from 'lucide-react';
import { formatDateTimeWord } from '@/lib/dateFormat';

const formatDateTime = (dateString) => {
  return formatDateTimeWord(dateString);
};

const OrderInteractionsTab = ({ orderData, onOpenInteractionDialog, onDeleteInteraction }) => {
  return (
    <Card className="bg-white border border-slate-200/50 shadow-sm">
      <CardHeader className="border-b border-slate-100 flex flex-row items-center justify-between">
        <CardTitle className="text-lg">Interactions & Fitting Sessions</CardTitle>
        <Button onClick={() => onOpenInteractionDialog()}>
          <Plus className="w-4 h-4 mr-2" />
          Add Interaction
        </Button>
      </CardHeader>
      <CardContent className="p-6">
        {!orderData.interactions?.length ? (
          <div className="text-center text-slate-500 py-8">
            <MessageSquare className="w-12 h-12 mx-auto mb-3 opacity-50" />
            <p>No interactions recorded</p>
          </div>
        ) : (
          <div className="space-y-4">
            {orderData.interactions.map((interaction) => (
              <div key={interaction.interaction_id} className="border border-slate-200 rounded-lg p-4 hover:shadow-sm transition-shadow">
                <div className="flex items-start justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <Badge variant="outline" className="capitalize">
                      {interaction.interaction_type}
                    </Badge>
                    <span className="text-sm text-slate-500">{formatDateTime(interaction.interaction_date)}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Button variant="ghost" size="icon" className="h-8 w-8" onClick={() => onOpenInteractionDialog(interaction)}>
                      <Edit2 className="w-4 h-4" />
                    </Button>
                    <Button variant="ghost" size="icon" className="h-8 w-8 text-red-500" onClick={() => onDeleteInteraction(interaction.interaction_id)}>
                      <Trash2 className="w-4 h-4" />
                    </Button>
                  </div>
                </div>
                {interaction.notes && (
                  <p className="text-sm text-slate-700">{interaction.notes}</p>
                )}
                {interaction.conducted_by && (
                  <p className="text-sm text-slate-500 mt-1">By: {interaction.conducted_by}</p>
                )}
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default OrderInteractionsTab;